import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProofSection() {
  return <section className="bg-navy text-text-light py-24 px-4 relative" data-id="element-188">
      <div className="max-w-4xl mx-auto text-center" data-id="element-189">
        <FadeIn data-id="element-190">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-cream mb-8" data-id="element-191">
            What Changes in <span className="text-copper italic" data-id="element-192">7 Days</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-193">
          <div className="bg-navy-light/40 border border-copper/20 p-8 md:p-12 rounded-sm shadow-2xl relative overflow-hidden" data-id="element-194">
            {/* Subtle glow effect */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-copper/5 blur-3xl rounded-full pointer-events-none" data-id="element-195" />

            <p className="text-xl md:text-2xl font-body leading-relaxed text-cream/90 relative z-10" data-id="element-196">
              By following this protocol, within one week you will have shifted
              from{' '}
              <span className="text-copper font-semibold" data-id="element-197">"anxious heir"</span>{' '}
              to{' '}
              <span className="text-copper font-semibold" data-id="element-198">
                "informed administrator."
              </span>
              <br data-id="element-199" />
              <br data-id="element-200" />
              The bank will be on notice, the house will be protected, and you
              will have a dated, HD record of every asset in the
              home—effectively ending family disputes before they start.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}